import ConfirmationModal from './ConfirmationModal/ConfirmationModal'
import VersionModal from './VersionModal/VersionModal'
import VersionModelModal from './VersionModelModal/VersionModelModal'
import DownloadSettings from './DownloadSettings'
import DeleteDevice from './DeleteDevice'
import ResetDeviceModal from './ResetDeviceModal/ResetDeviceModal'
import RenameDeviceModal from './RenameDeviceModal/RenameDeviceModal'
import AddDevice from './AddDevice'

export default {
  ConfirmationModal,
  VersionModal,
  VersionModelModal,
  DownloadSettings,
  DeleteDevice,
  ResetDeviceModal,
  RenameDeviceModal,
  AddDevice
}
